export class Accordion {
  constructor(accordion) {
    this.accordion = accordion;
    this.accordionHeaders = accordion.querySelectorAll(
      "[data-accordion-header]"
    );
    this.accordionContent = accordion.querySelectorAll(
      "[data-accordion-content]"
    );

    this.accordionHeaders.forEach((accordionHeader) => {
      const KEY_ENTER = 13;
      const slug = slugify(accordionHeader.textContent);
      const accordionContent = accordionHeader.nextElementSibling;

      accordionHeader.setAttribute("tabindex", 0);
      accordionHeader.setAttribute("aria-expanded", "false");
      accordionHeader.setAttribute("aria-controls", slug);
      accordionContent.setAttribute("aria-labelledby", slug);
      accordionContent.setAttribute("aria-hidden", "true");

      accordionHeader.addEventListener("click", () => {
        this.toggleAccordion(accordionHeader, accordionContent);
      });

      accordionHeader.addEventListener("keydown", (event) => {
        if(event.which === KEY_ENTER) {
          this.toggleAccordion(accordionHeader, accordionContent);
        }
      });
    });
  }

  toggleAccordion(accordionHeader, accordionContent) {
    if (accordionHeader.getAttribute("aria-expanded") === "false") {
      accordionHeader.setAttribute("aria-expanded", "true");
      accordionContent.setAttribute("aria-hidden", "false");
    } else {
      accordionHeader.setAttribute("aria-expanded", "false");
      accordionContent.setAttribute("aria-hidden", "true");
    }
  }
}

function slugify(string) {
  const a =
    "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
  const b =
    "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
  const p = new RegExp(a.split("").join("|"), "g");

  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(p, (c) => b.charAt(a.indexOf(c)))
    .replace(/&/g, "-and-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
}
